export default "__VITE_ASSET__DtKVRHvY__"